import React from 'react';
import { css } from 'emotion';
const widthOverride = css `
	iframe {
		min-width: 300px !important;
		max-width: 100%;
	}
`;
export const DocumentBlockComponent = ({ embedUrl, title, width, height }) => {
    return (React.createElement("div", { className: widthOverride },
        React.createElement("iframe", { src: embedUrl, title: title, height: height, width: width, allowFullScreen: true, "data-cy": "document-embed" })));
};
